const textProps = {
  icon: "fas fa-map-marker-alt",
  color: "lightBlue",
  title: "Address",
  description: "12124 First Street, nr 54",
};
export default textProps;
